import { index } from './utils';
import translations from '../app/translations/de';

index(translations);
